<div class="tabs-container">
  <div class="login-register-tabs-container">
    <div class="tabs-wrapper">
      @for (option of options; track option.value) {
        <button 
          type="button" 
          class="tab-button" 
          [class.active]="value === option.value"
          (click)="select(option.value)"
          [attr.aria-pressed]="value === option.value"
          [attr.aria-label]="option.ariaLabel || option.label">
          <span class="tab-text">{{ option.label }}</span>
        </button>
      }
    </div>
  </div>
</div> 